import React from "react";
import { MapPin, Phone, Mail, Clock, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DoveTrovarci() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const address = "Via Roma 123, 00100 Roma, Italia";
  const phone = "+39 06 12345678";
  const email = "info@dclegal.it";
  const hours = "Lun-Ven: 9:00-18:00";
  const googleMapsUrl = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2969.863927466666!2d12.496365!3d41.902783!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132f61b6532013ad%3A0x28f1c82e908503c4!2sVia%20Roma%2C%20Roma%20RM%2C%20Italy!5e0!3m2!1sen!2sus!4v1650000000000!5m2!1sen!2sus`;
  return;
}